export default __webpack_public_path__ + "static/css-731c3fd939823bdb6f9a42b100455dc6.png";